import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 p-3 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "col-md-12 mb-20 p-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_4 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_5 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_6 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_7 = {
  key: 4,
  class: "text-nowrap"
}
const _hoisted_8 = {
  key: 5,
  class: "text-nowrap"
}
const _hoisted_9 = {
  key: 7,
  class: "dropdown"
}
const _hoisted_10 = { class: "dropdown-menu" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 4 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 5 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 6 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 7 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 8 }
const _hoisted_27 = {
  class: "modal fade",
  id: "modal_transport",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_28 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_29 = { class: "modal-content p-15 p-md-40" }
const _hoisted_30 = { class: "modal-header" }
const _hoisted_31 = { class: "modal-title fs-5" }
const _hoisted_32 = { class: "modal-body" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-12 mb-20" }
const _hoisted_35 = {
  class: "form-group",
  label: "Choisir Transport",
  "label-for": "trans"
}
const _hoisted_36 = { class: "col-12 mb-20" }
const _hoisted_37 = {
  class: "form-group",
  "label-for": "name",
  label: "Le nombre de sacs"
}
const _hoisted_38 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_39 = {
  class: "form-group",
  "label-for": "name",
  label: "Code d\\'envoie"
}
const _hoisted_40 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.auth.can('ADD_BR_Z'))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "btn btn-primary",
              to: { name: 'AddReturnZonePage' },
              style: {"margin-right":"12px"}
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode(" Ajouter Bon de retour ", -1)
              ])),
              _: 1,
              __: [5]
            }))
          : _createCommentVNode("", true)
      ]),
      _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
      _createVNode(_component_vue_good_table, {
        columns: _ctx.columns,
        rows: _ctx.rows,
        responsive: ""
      }, {
        emptystate: _withCtx(() => [
          _createVNode(_component_center, null, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("Aucune entrées correspondants trouvés", -1)
            ])),
            _: 1,
            __: [6]
          })
        ]),
        "table-row": _withCtx((props) => [
          (props.column.field === 'note_ref')
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _createElementVNode("b", null, _toDisplayString(props.row.note_ref), 1)
              ]))
            : (props.column.field === 'for_name')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(props.row.for_name), 1))
              : (props.column.field === 'created_at')
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    (props.row.created_at != null)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.getDate(props.row.created_at)), 1),
                          _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1))
                        ], 64))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(props.row.by_name), 1)
                  ]))
                : (props.column.field === 'recieveds')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(props.row.recieveds) + " Colis ", 1))
                  : (props.column.field === 'total_parcel')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(props.row.total_parcel) + " Colis ", 1))
                    : (props.column.field === 'transport')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                          _createElementVNode("b", null, _toDisplayString(props.row.transport), 1),
                          _createElementVNode("small", null, _toDisplayString(props.row.transport_code), 1)
                        ]))
                      : (props.column.field === 'statut')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                            (props.row.statut == 0 && props.row.total_parcel === 0)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  pill: "",
                                  class: _normalizeClass(`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
              4
            )}`)
                                }, " Vide ", 2))
                              : _createCommentVNode("", true),
                            (props.row.statut == 0 && props.row.total_parcel !== 0)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  pill: "",
                                  class: _normalizeClass(`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
              props.row.statut
            )}`)
                                }, " Nouveau ", 2))
                              : (props.row.statut == 1)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 2,
                                    pill: "",
                                    class: _normalizeClass(`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
              props.row.statut
            )}`)
                                  }, " Enregistré ", 2))
                                : (props.row.statut == 2)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 3,
                                      pill: "",
                                      class: _normalizeClass(`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
              props.row.statut
            )}`)
                                    }, " Expédier vers Agence Principale ", 2))
                                  : (props.row.statut == 3)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 4,
                                        pill: "",
                                        class: _normalizeClass(`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
              props.row.statut
            )}`)
                                      }, " Reçu par Agence Principale ", 2))
                                    : _createCommentVNode("", true)
                          ], 64))
                        : (props.column.field === 'action')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _cache[18] || (_cache[18] = _createElementVNode("button", {
                                class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                type: "button",
                                "data-bs-toggle": "dropdown",
                                "aria-expanded": "false"
                              }, [
                                _createElementVNode("i", { class: "flaticon-dots" })
                              ], -1)),
                              _createElementVNode("ul", _hoisted_10, [
                                (props.row.statut == 0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                                      _createVNode(_component_router_link, {
                                        class: "dropdown-item",
                                        to: {
                    path: `/edit-return-zone/${props.row.id}/${props.row.note_ref}`,
                  }
                                      }, {
                                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                                          _createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Modifier ", -1)
                                        ])),
                                        _: 2,
                                        __: [8]
                                      }, 1032, ["to"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (props.row.statut == 2)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                                      _createVNode(_component_router_link, {
                                        class: "dropdown-item",
                                        to: {
                    path: `/scan-return-zone/${props.row.id}/${props.row.note_ref}`,
                  }
                                      }, {
                                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                                          _createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Modifier ", -1)
                                        ])),
                                        _: 2,
                                        __: [9]
                                      }, 1032, ["to"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (props.row.statut == 3)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                                      _createVNode(_component_router_link, {
                                        class: "dropdown-item",
                                        to: {
                    path: `/scan-return-zone/${props.row.id}/${props.row.note_ref}`,
                  }
                                      }, {
                                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                                          _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Modifier ", -1)
                                        ])),
                                        _: 2,
                                        __: [10]
                                      }, 1032, ["to"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                  (props.row.statut == 0 && props.row.total_parcel == 0) ||
                  (props.row.statut != 0 && props.row.total_parcel == 0)
                )
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.DeleteNote(props.row))
                                      }, _cache[11] || (_cache[11] = [
                                        _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Supprimer ", -1)
                                      ]), 8, _hoisted_15)
                                    ]))
                                  : _createCommentVNode("", true),
                                (props.row.statut == 0 && props.row.total_parcel != 0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.SaveBon(props.row))
                                      }, _cache[12] || (_cache[12] = [
                                        _createElementVNode("i", { class: "flaticon-diskette lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Enregistrer ", -1)
                                      ]), 8, _hoisted_17)
                                    ]))
                                  : _createCommentVNode("", true),
                                (props.row.statut == 1 && props.row.total_parcel != 0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.OpenBon(props.row))
                                      }, _cache[13] || (_cache[13] = [
                                        _createElementVNode("i", { class: "flaticon-unlock lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Ouvrir ", -1)
                                      ]), 8, _hoisted_19)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                  props.row.statut == 2 &&
                  props.row.total_parcel != 0 &&
                  _ctx.user.role_id == 1 &&
                  _ctx.user.id == 1
                )
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.Unsent(props.row))
                                      }, _cache[14] || (_cache[14] = [
                                        _createElementVNode("i", { class: "flaticon-unlock lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Expedier vers Enregistré ", -1)
                                      ]), 8, _hoisted_21)
                                    ]))
                                  : _createCommentVNode("", true),
                                (props.row.statut == 1 && props.row.total_parcel != 0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.Transport(props.row))
                                      }, _cache[15] || (_cache[15] = [
                                        _createElementVNode("i", { class: "flaticon-express-delivery lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Expedier ", -1)
                                      ]), 8, _hoisted_23)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("li", null, [
                                  _createElementVNode("button", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.GetPDF(props.row))
                                  }, _cache[16] || (_cache[16] = [
                                    _createElementVNode("i", { class: "flaticon-download lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Télécharger le bon ", -1)
                                  ]), 8, _hoisted_24)
                                ]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("button", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.TicketsPDF(props.row))
                                  }, _cache[17] || (_cache[17] = [
                                    _createElementVNode("i", { class: "flaticon-grid lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Voir étiquettes ", -1)
                                  ]), 8, _hoisted_25)
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(props.formattedRow[props.column.field]), 1))
        ]),
        _: 1
      }, 8, ["columns", "rows"]),
      _createVNode(_component_PaginatorContent, {
        pagination: _ctx.users,
        offset: 9,
        onPaginate: _ctx.getRecords
      }, null, 8, ["pagination", "onPaginate"])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("h1", _hoisted_31, " Expedier le bon : " + _toDisplayString(_ctx.TransRow?.note_ref), 1),
            _cache[20] || (_cache[20] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("form", {
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.expedierBon(_ctx.TransRow.id)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _cache[21] || (_cache[21] = _createElementVNode("label", { for: "driver" }, "Transport", -1)),
                    _createVNode(_component_v_select, {
                      class: "custom-select-height",
                      options: _ctx.transportList,
                      modelValue: _ctx.transport,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.transport) = $event)),
                      label: "name"
                    }, null, 8, ["options", "modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _cache[22] || (_cache[22] = _createElementVNode("label", { for: "sacs" }, "Le nombre de sacs", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sacs_transport) = $event)),
                      name: "sacs",
                      type: "number",
                      min: "0"
                    }, null, 512), [
                      [_vModelText, _ctx.sacs_transport]
                    ])
                  ])
                ]),
                (_ctx.transport?.type == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _cache[23] || (_cache[23] = _createElementVNode("label", { for: "code_transport" }, "Code d'envoie", -1)),
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.code_transport) = $event)),
                          name: "name"
                        }, null, 512), [
                          [_vModelText, _ctx.code_transport]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _cache[24] || (_cache[24] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Fermer ", -1)),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.expedierBon(_ctx.TransRow.id))),
              class: "btn btn-primary"
            }, " Enregistrer ")
          ])
        ])
      ])
    ])
  ], 64))
}